<template>
  <v-hover v-slot:default="{ hover }" open-delay="300">
    <v-card flat="" height="100%">
      <v-alert
        class="full-height ma-0 pa-0 full-width"
        :color="colorCard"
        :outlined="!!colorCard"
        tile
      >
        <v-img
          v-if="type == 'image'"
          :aspect-ratio="aspectRatio"
          class="grey lighten-3"
          height="100%"
          :src="file.path"
          v-on:error="errImg"
          v-on:load="loadImg"
        >
          <template v-slot:placeholder>
            <v-row
              v-if="!loadDone"
              align="center"
              class="fill-height ma-0"
              justify="center"
            >
              <Loading />
            </v-row>
            <v-row
              v-else-if="isError"
              align="center"
              class="fill-height ma-0"
              justify="center"
            >
              <span>Tải ảnh lỗi </span>
            </v-row>
          </template>
        </v-img>
        <v-responsive v-else-if="type == 'video'" :aspect-ratio="aspectRatio">
          <div class="video-container">
            <video>
              <source :src="file.path" type="video/mp4" />
              Sorry, your browser doesn't support embedded videos.
            </video>
          </div>
        </v-responsive>
        <v-responsive
          v-else
          :aspect-ratio="aspectRatio"
          class="full-height full-width"
        >
          <div
            class="d-flex align-center justify-center overflow-hidden flex-column full-height full-width"
          >
            <v-icon size="44">{{ getIcon(type) }}</v-icon>
            <div
              class="text-truncate text-center px-2 pb-1"
              :class="{
                'text-decoration-line-through error--text': file.is_delete,
                'success--text': file.is_new,
              }"
              style="width: 100%"
              :title="file.name"
              >{{ file.name }}</div
            >
          </div>
        </v-responsive>
      </v-alert>

      <v-overlay
        :value="hover"
        class="d-flex flex-column align-center justify-center"
        style="height: 100%"
        absolute
      >
        <div
          class="text-truncate text-center px-2 pb-1"
          :class="{
            'text-decoration-line-through error--text': file.is_delete,
            'success--text': file.is_new,
          }"
          style="width: 100%"
          :title="file.name"
        >
          <v-icon v-if="type" size="20" :title="type">
            {{ getIcon(type) }}
          </v-icon>
          {{ file.name }}
        </div>
        <div class="d-flex align-center justify-center">
          <slot name="extra" :type="type">
            <base-button
              v-if="isCanView"
              :disabled="file.loading"
              icon
              :loading="file.loading"
              tooltip="Xem"
              @click="viewFile(file, type)"
            >
              <v-icon>mdi-eye-outline</v-icon>
            </base-button>
            <base-button
              v-if="!file.is_new"
              color="primary"
              :disabled="file.loading"
              icon
              :loading="file.loading"
              tooltip="Tải xuống"
              @click="downloadFile(file)"
            >
              <v-icon>mdi-download</v-icon>
            </base-button>
            <slot name="extra-btn" :type="type" />
          </slot>
        </div>
      </v-overlay>
    </v-card>
  </v-hover>
</template>

<script>
import FileModuleMixin from './FileModuleMixin.js'
export default {
  mixins: [FileModuleMixin],
  props: {
    file: {
      required: true,
    },
    aspectRatio: { type: Number, default: 1 },
  },
  data: () => ({
    loadDone: false,
    isError: false,
  }),
  computed: {
    isCanView() {
      return this.canView(this.file, this.type)
    },
    colorCard() {
      if (this.file.is_delete) return 'error'
      if (this.file.is_new) return 'success'
      return ''
    },
    type() {
      return this.getType(this.file)
    },
  },
  methods: {
    errImg(e) {
      this.loadDone = true
      this.isError = true
    },
    loadImg(e) {
      this.loadDone = true
    },
  },
}
</script>

<style scoped lang="scss">
.v-card--reveal {
  bottom: 0;
  opacity: 1;
  position: absolute;
  width: 100%;
}
video {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: black;
}

div.video-container {
  position: relative;
  height: 100%;
  width: 100%;
}
.full-width::v-deep .v-alert__wrapper,
.full-width::v-deep .v-alert__content {
  width: 100%;
}
</style>
